export default {
  avatar_url: null,
  name: 'Joe Doe',
  role: 'Guest',
  phone_number: '(617) 123-1234',
  email: 'jbrooks@gmail.com',
};
